<template>
    <p>
        {{ date }}
    </p>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />{{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
    </p>
    <p>
        {{ creditBureau.address_name }} <br />
        {{ address.street }} <br />
        {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
    </p>
    <p class="letter-content">
        I previously wrote you to investigate and verify a bankruptcy listed on my credit report and I received a response that
        the bankruptcy was verified with the bankruptcy court.
    </p>
    <p class="letter-content">
        I contacted the {{ _.join(_.map(reportStore.getSelectedAccounts(1, creditBureau.id, 'public-record'), 'court'), ', ') }} courthouse to verify their information release policy. The court informed me that they do not provide
        anyone with a debtor’s full social security number and they do not provide ANY credit bureau ANY information about ANY
        bankruptcy cases. I have included a copy of the response from the courthouse for your reference.
    </p>
    <p class="letter-content">
        It is quite clear that someone from <strong>{{ creditBureau.name }}</strong> lied about verifying this bankruptcy with the courthouse. That is a
        violation of the Fair Credit Reporting Act (FCRA).
    </p>
    <p>
        As you know, it is also a violation of the FCRA to report inaccurate or unverifiable information on a credit report.
        Thus, I demand that you IMMEDIATELY REMOVE the following bankruptcy from my credit report:
        <br>
        <br>
        <template v-for="publicRecord in reportStore.getSelectedAccounts(1, creditBureau.id, 'public-record')">
            <strong>"{{ publicRecord.type }}"</strong>,<strong> Docket#: {{ publicRecord.reference_number }}</strong>
            <br />
        </template>
    </p>
    <p class="letter-content">
        Please respond to me in writing once this removal has been completed.
    </p>
    <p>
        Sincerely,
        <br />
        <br />
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />
    </p>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                _: _,
                address,
            };
        }
    };
</script>
